<template>
    <div class="reo-share-delete-container">
        <div class="user-card">
            <div class="card">
                <p class="sub-title">{{ $t('share.delete.user') }}</p>
                <p class="title">{{sharerName}}</p>
            </div>
        </div>
        <div class="share-table">
            <div class="title title1">{{ $t('share.delete.authority') }}</div>
            <div class="cell-group">
                <cell v-for="(item, idx) in auths" :key="('cell-manage-' + idx)" :title="item.title" :disabled="item.disabled">
                    <div slot="foot-icon" v-if="!!item.icon">
                        <span class="icon" :class="item.icon"></span>
                    </div>
                </cell>
            </div>
        </div>
        <div class="del-btn" @click="openPopUp">
            {{ $t('share.delete.deleteBtn') }}
        </div>
        <pop-up
            v-if="showPopUp"
            textAlign='left'
            :loading="loading"
            :title="$t('share.popUp.deleteTip')"
            :description="$t('share.popUp.deleteShare')"
            :buttons="buttons"
            @cancel="closePopUp"
            @delete="deleteShare">
        </pop-up>
        <pop-up
            v-if="showFailPopUp"
            textAlign='left'
            :title="$t('share.popUp.deleteTip')"
            :description="$t('share.popUp.deleteShareFail')">
        </pop-up>
    </div>
</template>

<script>
import popUp from '@/components/popUp';
import cell from '@/components/cell';
import { getDeviceInfo, deleteDeviceShare } from '@/api/share';
import { requestToApp } from '@/api/app';

export default {
    components: {
        cell,
        popUp
    },
    async created () {

        this.shareInfo = this.$route.query.shareInfo;
        this.uid = this.shareInfo.uid;
        this.shareId = this.shareInfo.shareid;
        this.deviceInfo = await getDeviceInfo( this.uid );
        // 根据设备 uid 获取设备包含的所有权限
        this.setDeviceAuth();
        requestToApp( 'modifyPageTitle', {title: this.$t( 'share.pageTitle.share' )});

    },
    methods: {
        setDeviceAuth () {

            this.auths = this.deviceInfo.channels[0].privileges && this.deviceInfo.channels[0].privileges.map( item => {

                return {
                    name: item.name,
                    title: item.title,
                    order: item.order
                };

            });
            this.auths.sort(( a, b ) => {

                return a.order - b.order;

            });
            // 根据params shareInfo 获取分享信息
            this.setShareInfo();

        },
        setShareInfo () {

            this.sharerName = this.shareInfo && this.shareInfo.nickName;
            let auths = this.shareInfo.channels[0].privileges && this.auths.map( item => {

                let auth = {
                    disabled: true,
                    title: item.title
                };
                this.shareInfo.channels[0].privileges.map( a => {

                    if ( item.name === a.name ) {

                        auth.disabled = false;
                        auth.icon = 'icon-check';

                    }

                });

                return auth;

            });
            this.auths = auths;

        },
        async deleteShare () {

            if ( !this.loading ) {

                this.loading = true;
                await deleteDeviceShare( this.shareId ).then(() => {

                    // 成功
                    this.loading = false;
                    this.closePopUp();
                    this.$router.go( -1 );

                }, () => {

                    // 删除失败
                    this.loading = false;
                    this.closePopUp();
                    this.openFailPopUp();
                    setTimeout(() => {

                        this.closeFailPopUp();

                    }, 3000 );

                });

            } else {

                return false;

            }

        },
        openPopUp () {

            this.showPopUp = true;

        },
        closePopUp () {

            this.showPopUp = false;

        },
        openFailPopUp () {

            this.showFailPopUp = true;

        },
        closeFailPopUp () {

            this.showFailPopUp = false;

        }
    },
    data () {

        return {
            loading: false,
            showPopUp: false,
            showFailPopUp: false,
            shareId: '', // 分享id
            sharerName: '',
            shareInfo: null, // 分享内容
            deviceInfo: null, // 设备内容
            auths: [],
            buttons: [
                {
                    click: 'cancel',
                    type: 'normal',
                    text: '取消'
                },
                {
                    click: 'delete',
                    type: 'warning',
                    text: '删除'
                }
            ]
        };

    }
};
</script>

<style lang="less">
.reo-share-delete-container {
    background-color: #F7F8F9;
    .user-card {
        width: 100%;
        height: 2rem;
        background: #FFFFFF;
        .card {
            padding: 0.3rem 0.3rem;
            text-align: left;
            .sub-title {
                color: #777;
                font-size: 0.26rem;
                line-height: 1.4;
            }
            .title {
                margin-top: 0.2rem;
                color: #333;
                font-size: 0.46rem;
            }
        }
    }
    .share-table {
        .title {
            color: #777777;
            font-size: 0.22rem;
            line-height: 0.4rem;
            padding: 0.6rem 0.3rem 0.1rem;
            background: #f7f8f9;
        }
        .cell-group {
            .reo-cell-box:nth-child(1) {
                .reo-cell::before{
                    display: none;
                }
            }
            .reo-cell .reo-cell_ficon .icon {
                background: linear-gradient(142deg, #1E70F1 0%, #1E8EEC 31%, #1DD5DF 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-size: .4rem !important;
            }
        }
    }
    .del-btn {
        margin-top: 0.6rem;
        height: 0.88rem;
        line-height: 0.88rem;
        text-align: center;
        font-size: 0.34rem;
        color: #FF5E62;
        background: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/share/shareDelete.vue